const isEs = () => (window.location.pathname.indexOf('/es/') !== -1);


module.exports = {
	isEs
};
